import React from "react";
import styles from "./ResumeButton.module.css";
import resumePdf from "../../assets/BoringResume2026.pdf";

export default function ResumeButton() {
  return (
    <a
      className={styles.resumeButton}
      href={resumePdf}
      download="Hasan-Boring-Resume.pdf"
      aria-label="Download Hasan resume"
    >
      <i className="fa-solid fa-download" aria-hidden="true"></i>
      <span>Download My Boring Resume</span>
    </a>
  );
}
